"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KEY_LEN = exports.CURRENT_CRYPTO_VERSION = exports.CRYPTO_V1 = exports.LOCAL_KEY_BYTES = exports.NONCE_BYTES = exports.SALT_BYTES = exports.RECOVERY_CODE_NWORDS = exports.RECOVERY_CODE_NBITS = void 0;
exports.encrypt = encrypt;
exports.decrypt = decrypt;
var utf8_1 = require("@stablelib/utf8");
var base64_1 = require("@stablelib/base64");
var scrypt_async_1 = __importDefault(require("scrypt-async"));
var tweetnacl_1 = __importDefault(require("tweetnacl"));
exports.RECOVERY_CODE_NBITS = 160;
exports.RECOVERY_CODE_NWORDS = (exports.RECOVERY_CODE_NBITS / 32) * 3;
exports.SALT_BYTES = 32;
exports.NONCE_BYTES = tweetnacl_1.default.secretbox.nonceLength; // 24 bytes
exports.LOCAL_KEY_BYTES = tweetnacl_1.default.secretbox.keyLength; // 32 bytes
exports.CRYPTO_V1 = 1;
exports.CURRENT_CRYPTO_VERSION = exports.CRYPTO_V1;
exports.KEY_LEN = tweetnacl_1.default.secretbox.keyLength; // 32 bytes
/**
 * Convert password from user into a derived key for encryption
 * @param {ScryptPassParams} params - The scrypt pass params.
 * @param {string} params.password plaintext password from user
 * @param {string} params.salt salt (should be randomly generated)
 * @param {number} params.dkLen length of the derived key to output
 * @returns {Uint8Array} bytes of the derived key
 */
function scryptPass(params) {
    var password = params.password, salt = params.salt, _a = params.dkLen, dkLen = _a === void 0 ? exports.KEY_LEN : _a;
    var _b = [32768, 8, 1], N = _b[0], r = _b[1], p = _b[2];
    return new Promise(function (resolve, reject) {
        (0, scrypt_async_1.default)(password, salt, { N: N, r: r, p: p, dkLen: dkLen, encoding: "binary" }, function (derivedKey) {
            if (derivedKey) {
                resolve(derivedKey);
            }
            else {
                reject(new Error("scryptPass failed, derivedKey is null"));
            }
        });
    });
}
function generateSalt() {
    return (0, base64_1.encode)(tweetnacl_1.default.randomBytes(exports.SALT_BYTES));
}
/**
 * Encrypt a phrase using scrypt.
 * @async
 * @param {object} params Params object
 * @param {string} params.phrase Phrase to be encrypted
 * @param {string} params.password A password to encrypt the string with.
 * @param {string} [params.salt] A static salt. Use only for unit tests.
 * @param {string} [params.nonce] A static nonce. Use only for unit tests.
 * @returns {Promise<EncryptResponse>} the encrypt response
 */
function encrypt(params) {
    return __awaiter(this, void 0, void 0, function () {
        var phrase, password, salt, nonce, secretboxSalt, secretboxNonce, scryptedPass, textBytes, cipherText, bundle;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    phrase = params.phrase, password = params.password, salt = params.salt, nonce = params.nonce;
                    secretboxSalt = salt || generateSalt();
                    secretboxNonce = nonce || tweetnacl_1.default.randomBytes(exports.NONCE_BYTES);
                    return [4 /*yield*/, scryptPass({ password: password, salt: secretboxSalt })];
                case 1:
                    scryptedPass = _a.sent();
                    textBytes = (0, utf8_1.encode)(phrase);
                    cipherText = tweetnacl_1.default.secretbox(textBytes, secretboxNonce, scryptedPass);
                    if (!cipherText) {
                        throw new Error("Encryption failed");
                    }
                    bundle = new Uint8Array(1 + secretboxNonce.length + cipherText.length);
                    bundle.set([exports.CURRENT_CRYPTO_VERSION]);
                    bundle.set(secretboxNonce, 1);
                    bundle.set(cipherText, 1 + secretboxNonce.length);
                    return [2 /*return*/, {
                            encryptedPhrase: (0, base64_1.encode)(bundle),
                            salt: secretboxSalt,
                        }];
            }
        });
    });
}
function decrypt(params) {
    return __awaiter(this, void 0, void 0, function () {
        var phrase, password, salt, scryptedPass, bundle, version, decryptedBytes, nonce, cipherText;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    phrase = params.phrase, password = params.password, salt = params.salt;
                    return [4 /*yield*/, scryptPass({ password: password, salt: salt })];
                case 1:
                    scryptedPass = _a.sent();
                    bundle = (0, base64_1.decode)(phrase);
                    version = bundle[0];
                    if (version === exports.CRYPTO_V1) {
                        nonce = bundle.slice(1, 1 + exports.NONCE_BYTES);
                        cipherText = bundle.slice(1 + exports.NONCE_BYTES);
                        decryptedBytes = tweetnacl_1.default.secretbox.open(cipherText, nonce, scryptedPass);
                    }
                    else {
                        throw new Error("Cipher version ".concat(version, " not supported."));
                    }
                    if (!decryptedBytes) {
                        throw new Error("That passphrase wasn’t valid.");
                    }
                    return [2 /*return*/, (0, utf8_1.decode)(decryptedBytes)];
            }
        });
    });
}
